module.exports = __webpack_public_path__ + "static/assets/1e69968a42d645e2f4ba4db187aa73d8.png";